import { collator } from '@aytm/app/stats/lib/helpers'

export const convertValuesToTree = (option, value, values, valueName = 'key') =>
  value != undefined && 0 < values.length
    ? 'multistatemultiselect' == option.type
      ? {
          [value.toUpperCase()]: values.reduce((acc, cur) => {
            acc[cur.value] = { x: cur.state }
            return acc
          }, {})
        }
      : 'sliderselect' == option.type
      ? {
          [value.toUpperCase()]: {
            x: true,
            v: [values.map(v => option.options[v - 1][valueName]).join('-')]
          }
        }
      : ['multiselect', 'inputtext'].includes(option.type) || ('dropdown' == option.type && option.subkey == undefined)
      ? {
          [value.toUpperCase()]: {
            x: true,
            v: 'dropdown' == option.type ? values : values.map(v => String(v))
          }
        }
      : 'dropdown' == option.type && option.subkey != undefined
      ? {
          [value.toUpperCase()]: {
            [option.subkey.toUpperCase()]: {
              x: true,
              v: values
            }
          }
        }
      : {
          [value.toUpperCase()]: {
            x: true
          }
        }
    : ['button', 'none'].includes(option.type)
    ? {
        [value.toUpperCase()]: {
          x: true
        }
      }
    : {
        [value.toUpperCase()]: {}
      }

export const convertTreeToValues = (option, tree, valueName = 'key') => {
  const flatOptions =
    ['multistatemultiselect', 'multiselect'].includes(option.type) && option.group
      ? option.options.flatMap(option => option.items)
      : option.options

  return tree != undefined && null !== tree
    ? 'multistatemultiselect' == option.type
      ? Object.keys(tree)
          .map(v => {
            const o = flatOptions.find(_v => null !== _v && 0 == collator.compare(String(_v[valueName]), String(v)))
            return o != undefined
              ? {
                  value: o[valueName],
                  state: tree[v].x
                }
              : null
          })
          .filter(o => o !== null)
          .sort(
            (a, b) => flatOptions.findIndex(v => v.value == a.value) - flatOptions.findIndex(v => v.value == b.value)
          )
      : 'sliderselect' == option.type
      ? (Array.isArray(tree.v) ? tree.v : [tree.v])
          .flatMap(v =>
            v != undefined && null !== v
              ? 'number' == typeof v
                ? [v, v]
                : v.replace(/^(.+?)-(.+)$/, '$1##$2').split(/##/)
              : null
          )
          .map(
            v =>
              option.options.findIndex(
                _v => _v != undefined && null !== _v && 0 == collator.compare(String(_v[valueName]), String(v))
              ) + 1
          )
          .filter(i => 0 < i)
      : 'multiselect' == option.type
      ? (Array.isArray(tree.v) ? tree.v : [tree.v])
          .map(v => {
            const o = flatOptions.find(_v => null !== _v && 0 == collator.compare(String(_v[valueName]), String(v)))
            return o != undefined ? o[valueName] : null
          })
          .filter(o => o !== null)
      : 'inputtext' == option.type || ('dropdown' == option.type && option.subkey == undefined)
      ? Array.isArray(tree.v)
        ? tree.v
        : [tree.v]
      : 'dropdown' == option.type && option.subkey != undefined && tree[option.subkey.toUpperCase()] != undefined
      ? Array.isArray(tree[option.subkey.toUpperCase()].v)
        ? tree[option.subkey.toUpperCase()].v
        : [tree[option.subkey.toUpperCase()].v]
      : []
    : []
}
